import { render, staticRenderFns } from "./wrapText.vue?vue&type=template&id=140b57ba&"
import script from "./wrapText.vue?vue&type=script&lang=js&"
export * from "./wrapText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports